module.exports = __webpack_public_path__ + "static/img/11.2a72d6a9.jpg";